import React from 'react';
import { FadeIn } from './FadeIn';
import { Compass, GraduationCap, House, ListChecks } from 'lucide-react';
const situations = [{
  icon: Compass,
  text: 'Quieres aprender a vender por internet pero no sabes por dónde empezar.'
}, {
  icon: ListChecks,
  text: 'Has visto muchos videos gratuitos y sigues sin tener un plan claro.'
}, {
  icon: House,
  text: 'Quieres aprender una habilidad que puedas desarrollar desde casa.'
}, {
  icon: GraduationCap,
  text: 'Buscas una guía organizada y paso a paso.'
}];
export function Identification() {
  return <section className="bg-brand-beige px-5 py-20 sm:px-6 md:py-28" data-id="element-339">
      <div className="mx-auto max-w-6xl" data-id="element-340">
        <FadeIn data-id="element-341">
          <div className="mx-auto mb-12 max-w-3xl text-center md:mb-14" data-id="element-342">
            <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-brand-gold" data-id="element-343">
              Antes de comenzar
            </p>
            <h2 className="font-serif text-3xl font-bold tracking-tight text-brand-green sm:text-4xl md:text-5xl" data-id="element-344">
              ¿Te identificas con alguna de estas situaciones?
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5" data-id="element-345">
          {situations.map((situation, index) => {
          const Icon = situation.icon;
          return <FadeIn key={situation.text} delay={0.08 * index} data-id="element-346">
                <article className="flex h-full items-start gap-4 rounded-2xl border border-brand-text/8 bg-white p-6 shadow-[0_8px_28px_-18px_rgba(26,26,26,0.2)] sm:p-7" data-id="element-347">
                  <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-brand-green/8" data-id="element-348">
                    <Icon className="h-5 w-5 text-brand-green" data-id="element-349" />
                  </span>
                  <p className="pt-1 text-base font-medium leading-relaxed text-brand-text/80 sm:text-lg" data-id="element-350">
                    {situation.text}
                  </p>
                </article>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}